import queryString from "query-string";

const token = Math.random().toString(36).substring(2,7);

const queryParams = queryString.parse(window.location.search).id;

const queryParamsmenu = queryString.parse(window.location.search).menu;

const domainurl = "https://convergenow.ai/platform/chatbot";
//const domainurl = "http://192.168.2.17:7004/platform/chatbot";

const insert_chat = process.env.INSERT_CHATDATA

console.log(token);
export { token, queryParams, domainurl, queryParamsmenu, insert_chat }